import type { DateTime } from 'luxon'

export function getGreatestDateTime(
  ...datetimes: (DateTime | undefined)[]
): DateTime | undefined {
  return datetimes
    .filter((dt): dt is DateTime => dt !== undefined)
    .reduce((greatest, current) => {
      if (!greatest) return current
      if (current > greatest) return current
      return greatest
    })
}
